// External
import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

// Components
import TableServerSideProvider from '~COMPONENTS/tableServerSide/TableServerSideContext';
import CatalogsCreateOrEdit from './catalogsCreateOrEdit/CatalogsCreateOrEdit';
import FindAndDeleteProductCodes from './findAndDeleteProductCodes/FindAndDeleteProductCodes';
import CatalogsList from './catalogsList/CatalogsList';

import {
  columnSortModifiersCatalogProductsList,
  columnFilterModifiersCatalogProductsList
} from './catalogsCreateOrEdit/columns';
import { columnSortModifiersCatalogList, columnFilterModifiersCatalogList } from './catalogsList/columns';
import {
  columnSortModifiersFindProductCodes,
  columnFilterModifiersFindProductCodes
} from './findAndDeleteProductCodes/columns';

export const Catalogs = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <TableServerSideProvider
          tableId='catalogs'
          columnSortModifiers={columnSortModifiersCatalogList}
          columnFilterModifiers={columnFilterModifiersCatalogList}
        >
          <CatalogsList />
        </TableServerSideProvider>
      </Route>
      <Route exact path={`${path}/new`}>
        <CatalogsCreateOrEdit />
      </Route>
      <Route exact path={`${path}/edit/:currentCatalogId`}>
        <TableServerSideProvider
          tableId='catalogProducts'
          columnSortModifiers={columnSortModifiersCatalogProductsList}
          columnFilterModifiers={columnFilterModifiersCatalogProductsList}
        >
          <CatalogsCreateOrEdit />
        </TableServerSideProvider>
      </Route>
      <Route exact path={`${path}/findDeleteProductCodes`}>
        <TableServerSideProvider
          tableId='findProductCodes'
          columnSortModifiers={columnSortModifiersFindProductCodes}
          columnFilterModifiers={columnFilterModifiersFindProductCodes}
        >
          <FindAndDeleteProductCodes />
        </TableServerSideProvider>
      </Route>
    </Switch>
  );
};

export default Catalogs;
